import { render, staticRenderFns } from "./LuckyGiftV3.vue?vue&type=template&id=0e344452&scoped=true"
import script from "./LuckyGiftV3.vue?vue&type=script&lang=js"
export * from "./LuckyGiftV3.vue?vue&type=script&lang=js"
import style0 from "./LuckyGiftV3.vue?vue&type=style&index=0&id=0e344452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e344452",
  null
  
)

export default component.exports